import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Trophy, Star, Shield, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { DjayAvatar, useDjaySelection } from '../mascot';
interface ChallengeIntroProps {
  isOpen: boolean;
  onStart: () => void;
  onCancel: () => void;
}
export function ChallengeIntro({
  isOpen,
  onStart,
  onCancel
}: ChallengeIntroProps) {
  const {
    selectedVariant
  } = useDjaySelection();
  return <AnimatePresence data-id="element-2609">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-2610">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={onCancel} data-id="element-2611" />
        
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-2612">
          
            {/* Header */}
            <div className="bg-gradient-to-r from-violet-500 to-fuchsia-500 p-6 text-white text-center relative" data-id="element-2613">
              <button onClick={onCancel} className="absolute top-4 right-4 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors" data-id="element-2614">
              
                <X className="w-5 h-5" data-id="element-2615" />
              </button>
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 backdrop-blur-md" data-id="element-2616">
                <Trophy className="w-8 h-8 text-white" data-id="element-2617" />
              </div>
              <h2 className="text-2xl font-black tracking-tight" data-id="element-2618">Uitdaging</h2>
            </div>

            {/* Content */}
            <div className="p-6 sm:p-8" data-id="element-2619">
              <div className="flex gap-4 items-start mb-6" data-id="element-2620">
                <div className="flex-shrink-0 mt-1" data-id="element-2621">
                  <DjayAvatar size="md" emotion="excited" variant={selectedVariant} animate={true} data-id="element-2622" />
                
                </div>
                <div className="bg-violet-50 rounded-2xl rounded-tl-none p-4 border border-violet-100 text-violet-900 text-sm font-medium leading-relaxed" data-id="element-2623">
                  Klaar voor een echte uitdaging? Kies een onderwerp waar je al
                  goed in bent en bewijs dat je het écht snapt!
                </div>
              </div>

              <div className="space-y-4 mb-8" data-id="element-2624">
                <div className="flex items-start gap-3" data-id="element-2625">
                  <div className="mt-0.5 bg-violet-100 p-1 rounded-full text-violet-600" data-id="element-2626">
                    <Shield className="w-4 h-4" data-id="element-2627" />
                  </div>
                  <div data-id="element-2628">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2629">
                      Minimaal 70% beheersing
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2630">
                      Je kunt alleen onderwerpen kiezen die je al goed beheerst.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2631">
                  <div className="mt-0.5 bg-fuchsia-100 p-1 rounded-full text-fuchsia-600" data-id="element-2632">
                    <Star className="w-4 h-4" data-id="element-2633" />
                  </div>
                  <div data-id="element-2634">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2635">
                      Verdien sterren
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2636">
                      Hoe beter je scoort, hoe meer sterren je verdient.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-2637">
                  <div className="mt-0.5 bg-amber-100 p-1 rounded-full text-amber-600" data-id="element-2638">
                    <Trophy className="w-4 h-4" data-id="element-2639" />
                  </div>
                  <div data-id="element-2640">
                    <p className="text-sm font-bold text-slate-800" data-id="element-2641">
                      Moeilijkere vragen
                    </p>
                    <p className="text-xs text-slate-500" data-id="element-2642">
                      De vragen zijn een niveau hoger — laat zien wat je kunt!
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-2643">
                <Button variant="secondary" onClick={onCancel} className="flex-1" data-id="element-2644">
                
                  Niet nu
                </Button>
                <Button variant="primary" onClick={onStart} className="flex-1 bg-gradient-to-r from-violet-500 to-fuchsia-500 hover:from-violet-600 hover:to-fuchsia-600 border-none shadow-lg shadow-violet-200" data-id="element-2645">
                
                  Kies onderwerp
                </Button>
              </div>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}